import { ReactElement, useContext } from "react";

import { StyledAutoFixHighIcon } from "@/shared/ui/ai-button/AiIcon";
import { SharedAiButtonStyles } from "@/shared/ui/ai-button/AiStyles";
import { Button, ButtonProps, styled } from "@mui/material";
import { Language } from "@/model/Language/Language";

import { TranslationContext } from "@/app/providers";

import { GetLanguageValueAsString } from "@/app/application/Translate";


const StyledAiButton = styled(Button, {
	shouldForwardProp: (prop) => prop !== "loading",
})<ButtonProps & { loading?: boolean }>(({ loading }) =>
	SharedAiButtonStyles(loading),
);

type Props = {
	loading: boolean;
	onClick: () => void;
	buttonText: ReactElement | string;
};

export const AiButton = ({ loading, onClick, buttonText }: Props) => {
	const translation: Language | null = useContext(TranslationContext);

	return (
		<StyledAiButton
			aria-label={GetLanguageValueAsString(
				translation,
				"Auto.Shared.Ui.AiButton.AiButton.L20C29.AIFunction",
				"AI Function",
			)}
			onClick={onClick}
		>
			<StyledAutoFixHighIcon loading={loading} fontSize="small" />
			{buttonText}
		</StyledAiButton>
	);
};
